import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { CurrentService } from "./current.service";
import { DatasService } from "./datas.service";
import { UserService } from "./user.service";

@Injectable()
export class EventDataTransferService {
  constructor(
    private userService: UserService,
    private currentService: CurrentService,
    private dataService: DatasService
  ) { }

  public transmitData(eventName: string, total_amount?: number) {
    let userType: string = "anonymous";
    let userId: string = "";

    if (this.userService.userDatas?.magentoId) {
      if (this.userService.userDatas?.vendor) {
        userType = "vendor";
        userId = this.userService.userDatas?.magentoId;
      } else {
        userType = "customer";
      }
    }

    const eventData: EventData = {
      event_name: eventName,
      country: this.userService.country,
      project_id: this.currentService.project?.id,
      original_project_id: this.currentService.project?.originalId,
      project_name: this.currentService.project?.name,
      project_type: this.userService.context,
      total_amount: total_amount ?? 0,
      date_event: new Date(),
      user_type: userType,
      store_id: this.userService.userDatas?.storeId.toString(),
      user_id: userId.toString(),
      user_id_hbm: this.userService.userDatas?.otherAccount ? this.userService.userDatas.otherAccount.hbmId : this.userService.userDatas?.hbmId
    };

    if (environment.gtm.debug) {
      this._logLayerDataPush(eventData);
    }

    this.dataService.insertEventData(eventData);
  }

  private _logLayerDataPush(eventData: EventData) {
    console.log("#######  Event Data #######");
    console.table(eventData);
  }
}

export class EventData {
  event_name: string;
  store_id?: string;
  country: string;
  user_id?: string; // only if vendor
  user_id_hbm: string;
  user_type: string;
  project_id: number;
  original_project_id: number;
  project_name: string;
  project_type: string;
  date_event: Date;
  total_amount?: number;
}
